<template>
    <div>
        <b-modal v-model="isVisible" hide-footer>
            <b-img
                :src="model && model.url"
                fluid
                alt="Responsive image"
            ></b-img>
            <br />
            <div>
                <b-button variant="warning" @click="deleteAttachment(model.id)"
                    >Delete</b-button
                >
            </div>
        </b-modal>

        <b-row>
            <b-col cols="4">
                <b-form-file id="uploadData" @change="uploadFile"></b-form-file>
            </b-col>
        </b-row>

        <b-container fluid class="p-4 mt-4 bg-dark">
            <b-row>
                <b-col
                    v-for="(item, index) in cleanedAttachments"
                    :key="index"
                    md="3"
                >
                    <b-button @click="setModel(item)">
                        <b-img
                            thumbnail
                            fluid
                            :src="item.url"
                            alt="Image 1"
                        ></b-img>
                    </b-button>
                </b-col>
                <b-col v-if="!cleanedAttachments.length">
                    <h4 class="text-white">No Attachments Submitted</h4>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'attachments',

    mixins: [popupMixins],
    props: {
        order: {
            type: Object,
        },
    },
    data() {
        return {
            submitting: false,
            model: null,
            isVisible: false,
        }
    },
    computed: {
        cleanedAttachments() {
            return ((this.order && this.order.attachments) || []).map(x => {
                if (x.url.indexOf(this.$OMSOldStorageUrl) === 0) {
                    x.url = x.url.replace(
                        this.$OMSOldStorageUrl,
                        this.$OMSStorageUrl
                    )
                }
                return x
            })
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
    },
    methods: {
        setModel(item) {
            console.log('item', item)
            this.model = {}
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isVisible = true
        },
        uploadFile(event) {
            console.log('upload event', event)
            const $this = this
            if (!navigator.geolocation) {
                console.log('problem with navigator')
                $this.doToast(
                    'Error!',
                    'Error Adding Attachment! Need Permissions to Get Coordinates',
                    'danger'
                )
            } else
                navigator.geolocation.getCurrentPosition(async p => {
                    try {
                        console.log('coordinates', p)
                        const lat = p.coords.latitude
                        const long = p.coords.longitude

                        console.log(event.target.files)
                        const { key, name } = await $this.$store.dispatch(
                            's3files/s3upload',
                            event.target.files
                        )

                        const url = `${$this.$OMSStorageUrl}/${key}`
                        console.log({ key, name, url })

                        const payload = { url, lat, long }
                        payload.order_id = $this.order.id

                        await $this.$store.dispatch(
                            'orders/addAttachment',
                            payload
                        )

                        $this.$store.dispatch(
                            'orders/fetchById',
                            $this.order.id
                        )
                        $this.doToast(
                            'Image Added!',
                            'Attachment Added!',
                            'success'
                        )
                    } catch (error) {
                        console.error('addAttachement', error)

                        $this.doToast(
                            'Error!',
                            'Error Adding Attachment!',
                            'danger'
                        )
                    } finally {
                        $this.submitting = false
                    }
                })
        },
        deleteAttachment(id) {
            const title = 'Delete Attachment?'
            const message = `Are you sure you want to delete this attachment?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return

                this.submitting = true
                const payload = {
                    order_id: this.order.id,
                    attachment_id: id,
                }

                this.$store
                    .dispatch('orders/deleteAttachment', payload)
                    .then(() => {
                        this.$store.dispatch('orders/fetchById', this.order.id)
                        this.doToast(
                            'Deleted!',
                            'Attachment Deleted!',
                            'success'
                        )
                        this.isVisible = false
                    })
                    .catch(error => {
                        console.error(error)

                        this.doToast(
                            'Error!',
                            'Error Deleting Attachment!',
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
</style>